import React, {useCallback} from 'react';
import dayjs from 'dayjs';
import {Button} from '../button';
import {Layout} from '../layout';
import {Text} from '../text';
import {getCapitalized} from '../../utils';

type Props = {
  currentMonth: Date;
  onChange?: (date: Date) => void;
};

export const Months: React.FC<Props> = ({currentMonth, onChange}) => {
  // Callbacks
  const handleGotoPreviousMonth = useCallback(
    () => onChange && onChange(dayjs(currentMonth).add(-1, 'month').toDate()),
    [currentMonth, onChange],
  );

  const handleGotoNextMonth = useCallback(
    () => onChange && onChange(dayjs(currentMonth).add(1, 'month').toDate()),
    [currentMonth, onChange],
  );

  return (
    <Layout justify="space-between" horizontal paddingBottom="8">
      <Button
        kind="Clear"
        leftIcon="arrowLeft"
        onPress={handleGotoPreviousMonth}
      />
      <Layout horizontal centered>
        <Text variant="inline_16_emphasis" align="center">
          {getCapitalized(
            currentMonth.toLocaleString('default', {
              month: 'long',
              year: 'numeric',
            }),
          )}
        </Text>
      </Layout>
      <Button
        kind="Clear"
        rightIcon="arrowRight"
        onPress={handleGotoNextMonth}
      />
    </Layout>
  );
};
